export default __webpack_public_path__ + "static/media/cleanproStampBanner.0a410475.jpg";